import './index.scss'
import axios from 'axios';
import Template from './index.handlebars';
// import Vconsole from 'vconsole';
import {HOST, downloadApk} from '../../common/js/constant.js';
axios.defaults.baseURL = HOST;
const NUMS_PER_PAGE = 6;
/* eslint-disable no-new */
// new Vconsole();
/* eslint-enable no-new */

var app = {
  pageIndex: 1,
  loadComplete: false,
  init () {
    let self = this;
    self.getList();
    self.bindEvent();
  },
  bindEvent () {
    let self = this;
    window.onscroll = function () {
      console.log(getScrollTop(), getWindowHeight(), getScrollHeight())
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 140) {
        self.getList();
      }
    };
    document.getElementById('main').addEventListener('click', function (e) {
      let $target = e.target;
      let $current;
      if ($target.classList.contains('video-item')) {
        $current = $target;
      }
      if ($target.classList.contains('icon-play')) {
        $current = $target.parentNode;
      }
      if ($current) {
        let thumbnail = $current.dataset['thumbnail'];
        let url = $current.dataset['url'];
        let showwhat = $current.dataset['showwhat'];
        let id = $current.dataset['id'];
        location.href = `./video-details.html?showwhat=${showwhat}&id=${id}&url=${encodeURIComponent(url)}&thumbnail=${encodeURIComponent(thumbnail)}`;
        // location.href = `./video-details.html?showwhat=${showwhat}`;
      }
    });
    document.querySelector('header').addEventListener('click', function (e) {
      self.log('click', 'top_apk');
      // location.href = DOWNLOAD_LINK;
      downloadApk()
    });
    document.querySelector('.btn-download').addEventListener('click', function (e) {
      self.log('click', 'install');
      // location.href = DOWNLOAD_LINK;
      downloadApk()
    });
    pushHistory();
    window.addEventListener('popstate', function () {
      location.replace('http://4funindia.com/beautifulGirl/10329279#');
      // history.back();
    }, false)
    function pushHistory () {
      var state = {
        title: 'title',
        url: '#'
      };
      window.history.pushState(state, 'title', '#');
    }
  },
  log (action, label, category = 'index') {
    if (!window._czc) window.czc = [];
    window._czc.push(['_trackEvent', category, label, action]);
  },
  dataRequestting: false, // 防抖
  getList () {
    let self = this;
    if (self.dataRequestting) return;
    self.dataRequestting = true;
    if (!self.loadComplete) {
      axios.get(`web/post/list?pageSize=${NUMS_PER_PAGE}&pageIndex=${self.pageIndex}`).then(response => {
        self.dataRequestting = false;
        if (response.status === 200) {
          let res = response.data.data;
          if (res.postList.length <= 0 || self.pageIndex * NUMS_PER_PAGE >= res.totalCount) {
            self.loadComplete = true;
          }
          let html = Template({list: res.postList});
          let $main = document.getElementById('list-cont');
          $main.innerHTML = $main.innerHTML + html;
          self.pageIndex++;
        }
      }).catch(function (err) {
        console.log(err);
        self.dataRequestting = false;
      })
    }
  }
}

function getScrollTop () {
  var scrollTop = 0;
  var bodyScrollTop = 0;
  var documentScrollTop = 0;
  if (document.body) {
    bodyScrollTop = document.body.scrollTop;
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop;
  }
  scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
  return scrollTop;
}
// 文档的总高度
function getScrollHeight () {
  var scrollHeight = 0;
  var bodyScrollHeight = 0;
  var documentScrollHeight = 0;
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight;
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight;
  }
  scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
  return scrollHeight;
}
function getWindowHeight () {
  var windowHeight = 0;
  if (document.compatMode === 'CSS1Compat') {
    windowHeight = document.documentElement.clientHeight;
  } else {
    windowHeight = document.body.clientHeight;
  }
  return windowHeight;
}

app.init()
